import { addGETParams } from '../../config'
import ax from '../api'

export const getUserModifiedDetails = async () => {
	const { data } = await ax.get('/management/user/modified.php')
	return data
}

/*
 * Get users list
 * @param {object} params - Parameters to filter and paginate the users list
 * $returns {object} The response from the server
 */
export const getUsersList = async (params) => {
	const _url = addGETParams(`/management/user/lst.php`, params)

	const { data } = await ax.get(_url)
	return data
}

/*
 * User get and set (update or insert)
 * @param {string} userId - The id of the user
 * $returns {object} The response from the server
 */
export const getUserByUid = async (userId, include_full = 'false') => {
	return await ax.get(
		`/management/user/get.php?user_id=${userId}&include_full=${include_full}`
	)
}

export const getUserDashboardData = async () => {
	return await ax.get(`/management/user/dashboard.php`)
}

/*
 * Set a user on the server
 * @param {string} userId - The id of the user
 * @param {object} full - The full object of the user
 * @returns {object} The response from the server
 */
export const setUser = async (userId, full, allowed) => {
	// Convert full object to JSON string
	const fullStr = JSON.stringify(full)
	const allowedStr = JSON.stringify(allowed)

	// Send POST request with data in the body
	try {
		const response = await ax.post(`/management/user/set.php`, {
			user_id: userId,
			full: fullStr,
			allowed: allowedStr
		})
		return response
	} catch (error) {
		console.error('Error in setUser:', error)
		throw error
	}
}

/*
 * User login and registration
 * @param {object} values - The values to send to the server
 * @returns {object} The response from the server
 * @example
 * const values = {
  	username: 'myusername',
  	password: 'mypassword'
  }
 *
 */

export const login = async (values) => {
	const { data } = await ax.post('/management/user/login.php', values)
	return data
}

/*
 * Register a new user
 * @param {object} values - The values to send to the server
 * @returns {object} The response from the server
 * @example
 * const values = {
  	username: 'myusername',
  	password: 'mypassword'
  }
 *
 */
export const register = async (values) => {
	const { data } = await ax.post('/management/user/register.php', values)
	return data
}

/*
 * Reset user password
 * @param {object} values - The values to send to the server
 * @returns {object} The response from the server
 * @example
 * const values = {
  	email: 'mymail@gmail.com',
  	password: 'mypassword'
  }
 *
 */
export const resetPassword = async (values) => {
	const { data } = await ax.post(
		'/management/user/reset-password.php',
		values
	)
	return data
}
export const resetPasswordConfirmation = async (email) => {
	const { data } = await ax.post(
		'/management/user/reset-password-confirmation.php',
		{
			email: email
		}
	)
	return data
}
/*
 * Sends an email using the specified values.
 * @param {object} values - The values to send to the server
 * @returns {object} The response from the server
 * @example
 * const values = {
    email: 'example@example.com',
    subject: 'Hello!',
    body: 'This is a test email.'
  }
 *
 */
export const sendEmail = async (values) => {
	const { data } = await ax.post('/management/user/email.php', values)
	return data
}

/*
 * Sends a request to delete a user with the specified values.
 * @param {object} values - The values to send to the server
 * @param {string} values.user_id - The ID of the user to be deleted
 * @returns {object} The response from the server
 * @throws {Error} Throws an error if the request fails
 * @example
 * const values = {
 *   user_id: '12345'
 * };
 * const response = await deleteUser(values);
 */
export const deleteUser = async (values) => {
	const { data } = await ax.post('/management/user/delete.php', values)
	return data
}
